@if (appUpdate.updateAvailable()) {
  <div class="app-update-banner" role="status" aria-live="polite">
    <div>
      <strong>A new version is available - refresh/clear cache to update.</strong>
      <span>Save your work and finish any uploads before refreshing.</span>
    </div>
    <button mat-raised-button type="button" (click)="appUpdate.refresh()">Refresh to update</button>
  </div>
}
@if (!service.isLoggedIn) {
  <login></login>
}
@if (service.isLoggedIn) {
  <!-- router-outlet must stay permanently mounted: destroying/recreating it whenever
       legal.allowed() toggles breaks in-flight Router navigation silently (no console
       error). The acceptance gate is instead rendered as an overlay on top of it. -->
  <router-outlet></router-outlet>
  @if (!legal.allowed()) {
    <app-legal-agreement></app-legal-agreement>
  }
}
